import { apiRegistry } from '../../../common/infra/apiRegistry'
import { filesMem } from '../mem/filesMem'

apiRegistry.registerPostApi('toggleStar', async (request) => {
  const { fileId, starred } = request

  const file = filesMem[fileId]
  if (!file) {
    throw new Error('File not found')
  }

  file.isStarred = starred
  file.modifiedDate = new Date().toISOString()

  return { file }
})